import { render, staticRenderFns } from "./MenuVue.vue?vue&type=template&id=17cc7db8&scoped=true"
import script from "./MenuVue.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuVue.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuVue.vue?vue&type=style&index=0&id=17cc7db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc7db8",
  null
  
)

export default component.exports